import { FtToFtDbl, FtToFt } from "./FeetIn";
import { isNullOrWhitespace, isString, getParameterCaseInsensitive } from "./utils";

export class TrimOptionsManager {
    #Coils: Coil[] = new Array<Coil>();
    #loading = false;
    calculateCustomTrimPrice: CallableFunction;

    #descriptionInput: HTMLInputElement;
    #descriptionIncludeLengthInput: HTMLInputElement;
    #descriptionIncludeCoilInput: HTMLInputElement;
    #descriptionIncludeColorInput: HTMLInputElement;

    #lengthInput: HTMLInputElement;
    #colorInput: HTMLSelectElement;
    #coilInput: HTMLSelectElement;
    #ReversePaintSideInput: HTMLInputElement;


    constructor() {
    }

    private _Name: string = "Custom Trim";
    public get Name(): string {
        return this._Name;
    }
    public set Name(v: string) {
        this._Name = v;
        this.writeValuesToInputs();
    }

    private _Length: number = 0;
    public get Length(): number {
        return this._Length;
    }
    public set Length(v: number) {
        this._Length = v;
        this.writeValuesToInputs();
    }
    public get LengthText(): string {
        return FtToFt(this.Length);
    }
    public set LengthText(v: string) {
        this.Length = FtToFtDbl(v);
        this.writeValuesToInputs();
        this.calculatePrice();
    }

    #_DescriptionIncludeLength: boolean = true;
    public get DescriptionIncludeLength(): boolean {
        return this.#_DescriptionIncludeLength;
    }
    public set DescriptionIncludeLength(v: boolean) {
        this.#_DescriptionIncludeLength = v;
        this.writeValuesToInputs();
    }

    private _DescriptionIncludeColor: boolean = true;
    public get DescriptionIncludeColor(): boolean {
        return this._DescriptionIncludeColor;
    }
    public set DescriptionIncludeColor(v: boolean) {
        this._DescriptionIncludeColor = v;
        this.writeValuesToInputs();
    }

    private _DescriptionIncludeCoil: boolean = false;
    public get DescriptionIncludeCoil(): boolean {
        return this._DescriptionIncludeCoil;
    }
    public set DescriptionIncludeCoil(v: boolean) {
        this._DescriptionIncludeCoil = v;
        this.writeValuesToInputs();
    }

    private _SelectedCoil: string;
    public get SelectedCoil(): string {
        return this._SelectedCoil;
    }
    public set SelectedCoil(v: string) {
        this._SelectedCoil = v;

        let L = this.#colorInput.options.length - 1;
        for (let i = L; i >= 0; i--) {
            this.#colorInput.remove(i);
        }
        let colors = this.#Coils.find(c => c.Id == Number(this.SelectedCoil))?.Colors;
        if (colors === undefined) return;
        for (let i = 0; i < colors.length; i++) {
            const color = colors[i];
            let colorOption = document.createElement("option");
            colorOption.value = color.Id.toString();
            colorOption.text = color.Description;

            if (color.Id === Number(this.SelectedColor)) {
                colorOption.selected = true;
            }
            this.#colorInput.add(colorOption);
        }
        this.writeValuesToInputs();
        this.calculatePrice();
    }

    private _SelectedColor: string;
    public get SelectedColor(): string {
        return this._SelectedColor;
    }
    public set SelectedColor(v: string) {
        this._SelectedColor = v;
        this.writeValuesToInputs();
        this.calculatePrice();
    }

    public get ColorName(): string {
        let coil = this.#Coils.find(c => c.Id == Number(this.SelectedCoil));
        if (coil == null) return "";
        let color = coil.Colors.find(c => c.Id == Number(this.SelectedColor));
        if (color == undefined) return "";
        return color.Description;
    }

    public get CoilName(): string {
        let coil = this.#Coils.find(c => c.Id == Number(this.SelectedCoil));
        if (coil == null) return "";
        return coil.Description;
    }


    private _BlankWidthText: string = "";
    public get BlankWidthText(): string {
        return this._BlankWidthText;
    }
    public set BlankWidthText(v: string) {
        this._BlankWidthText = v;
        this.writeValuesToInputs();
    }

    private _ReversePaintedSide: boolean = false;
    public get ReversePaintedSide(): boolean {
        return this._ReversePaintedSide;
    }
    public set ReversePaintedSide(v: boolean) {
        this._ReversePaintedSide = v;
        this.writeValuesToInputs();
    }


    calculatePrice() {
        if (this.#loading) return;
        if (this.calculateCustomTrimPrice == null) return;
        this.calculateCustomTrimPrice(this.updatePrice);
    }

    updatePrice(price: number) {
        document.getElementById('nctdPriceLabel')!.textContent = `Price: ${price}`;
    }

    LoadCoils(coilJsonData: any) {
        let coilObjects: any;
        this.#Coils.length = 0;
        if (isString(coilJsonData)) {
            coilObjects = JSON.parse(coilJsonData);
        } else {
            coilObjects = coilJsonData
        }

        for (let i = 0; i < coilObjects.length; i++) {
            const coilObject = coilObjects[i];
            const colors = new Array<ProductColor>();
            for (let j = 0; j < coilObject.colors.length; j++) {
                const color = coilObject.colors[j];
                colors.push(new ProductColor(color.id, color.code, color.description));
            }
            let coil = new Coil(coilObject.id, coilObject.code, coilObject.description, colors)
            this.#Coils.push(coil);

            let option = document.createElement("option");
            option.value = coil.Id.toString();
            option.text = coil.Description;
            this.#coilInput.add(option);
        }
    }

    loadCustomTrimOptions(customTrimJson: any) {
        this.#loading = true;
        let customTrimObject: object;
        if (isString(customTrimJson)) {
            customTrimObject = JSON.parse(customTrimJson);
        } else {
            customTrimObject = customTrimJson
        }

        let name = getParameterCaseInsensitive(customTrimObject, "name");
        this.Name = name === undefined ? this.Name : name;

        let color = getParameterCaseInsensitive(customTrimObject, "colorId");
        this.SelectedColor = color === undefined ? this.SelectedColor : color;

        let coil = getParameterCaseInsensitive(customTrimObject, "coilId");
        this.SelectedCoil = coil === undefined ? this.SelectedCoil : coil;

        let length = getParameterCaseInsensitive(customTrimObject, "length");
        this.Length = length === undefined ? this.Length : length;

        this.DescriptionIncludeLength = true;
        if (customTrimObject.hasOwnProperty("DescriptionIncludeLength")) {
            this.DescriptionIncludeLength = getParameterCaseInsensitive(customTrimObject, "DescriptionIncludeLength");
        }
        this.DescriptionIncludeCoil = false;
        if (customTrimObject.hasOwnProperty("DescriptionIncludeCoil")) {
            this.DescriptionIncludeCoil = getParameterCaseInsensitive(customTrimObject, "DescriptionIncludeCoil");
        }
        this.DescriptionIncludeColor = true;
        if (customTrimObject.hasOwnProperty("DescriptionIncludeColor")) {
            this.DescriptionIncludeColor = getParameterCaseInsensitive(customTrimObject, "DescriptionIncludeColor");
        }
        this.ReversePaintedSide = false;
        if (customTrimObject.hasOwnProperty("ReversePaintedSide")) {
            this.ReversePaintedSide = getParameterCaseInsensitive(customTrimObject, "ReversePaintedSide");
        }
        let price = 0;
        if (customTrimObject.hasOwnProperty("Price")) {
            price = Number(getParameterCaseInsensitive(customTrimObject, "Price"));
        }
        this.updatePrice(price);

        this.#loading = false;
    }


    getDescription(): string {
        return this.Name + (this.DescriptionIncludeLength ? " " + FtToFt(this.Length) : "")
            + (this.DescriptionIncludeCoil && !isNullOrWhitespace(this.CoilName) ? " " + this.CoilName : "")
            + (this.DescriptionIncludeColor && !isNullOrWhitespace(this.ColorName) ? " " + this.ColorName : "");
    }


    init() {
        let me = this;
        me.#descriptionInput = document.getElementById("nctdDescriptionInput") as HTMLInputElement;
        me.#descriptionInput.addEventListener("input", function () {
            me.Name = this.value;
        });
        me.#descriptionIncludeLengthInput = document.getElementById("nctdIncludeLength") as HTMLInputElement;
        me.#descriptionIncludeLengthInput.addEventListener("change", function () {
            me.DescriptionIncludeLength = this.checked;
        });
        me.#descriptionIncludeCoilInput = document.getElementById("nctdIncludeCoilDescription") as HTMLInputElement;
        me.#descriptionIncludeCoilInput.addEventListener("change", function () {
            me.DescriptionIncludeCoil = this.checked;
        });
        me.#descriptionIncludeColorInput = document.getElementById("nctdIncludeColorDescription") as HTMLInputElement;
        me.#descriptionIncludeColorInput.addEventListener("change", function () {
            me.DescriptionIncludeColor = this.checked;
        });
        me.#lengthInput = document.getElementById("nctdLength") as HTMLInputElement;
        me.#lengthInput.addEventListener("change", function () {
            me.LengthText = this.value;
        });
        me.#colorInput = document.getElementById("nctdColor") as HTMLSelectElement;
        me.#colorInput.addEventListener("change", function () {
            me.SelectedColor = this.value;
        });
        me.#coilInput = document.getElementById("nctdCoil") as HTMLSelectElement;
        me.#coilInput.addEventListener("change", function () {
            me.SelectedCoil = this.value;
        });
        me.#ReversePaintSideInput = document.getElementById("nctdReversePaintSide") as HTMLInputElement;
        me.#ReversePaintSideInput.addEventListener("change", function () {
            me.ReversePaintedSide = this.checked;
        });
        (<HTMLButtonElement>document.getElementById("nctdCalculateTrimPrice"))
            .addEventListener("click", function () {
                me.calculatePrice();
            });

    }

    writeValuesToInputs() {
        let me = this;
        me.#descriptionInput.value = me.Name;
        me.#descriptionIncludeLengthInput.checked = me.DescriptionIncludeLength;
        me.#descriptionIncludeCoilInput.checked = me.DescriptionIncludeCoil;
        me.#descriptionIncludeColorInput.checked = me.DescriptionIncludeColor;
        me.#lengthInput.value = me.LengthText;
        me.#colorInput.value = me.SelectedColor;
        me.#coilInput.value = me.SelectedCoil;
        me.#ReversePaintSideInput.checked = me.ReversePaintedSide;
        document.getElementById("nctdDescriptionLabel")!.textContent = me.getDescription();
        document.getElementById("nctdBlankWidthLabel")!.textContent = "Blank Width: " + this.BlankWidthText;
    }
}


class Coil {
    constructor(id: number, code: string, description: string, productColors: ProductColor[]) {
        this.Id = id;
        this.Code = code;
        this.Description = description;
        this.Colors = productColors;
    }

    private _Id: number;
    public get Id(): number {
        return this._Id;
    }
    public set Id(v: number) {
        this._Id = v;
    }

    private _Code: string;
    public get Code(): string {
        return this._Code;
    }
    public set Code(v: string) {
        this._Code = v;
    }

    private _Description: string;
    public get Description(): string {
        return this._Description;
    }
    public set Description(v: string) {
        this._Description = v;
    }

    private _Colors: ProductColor[];
    public get Colors(): ProductColor[] {
        return this._Colors;
    }
    public set Colors(v: ProductColor[]) {
        this._Colors = v;
    }
}

class ProductColor {
    constructor(id: number, code: string, description: string) {
        this.Id = id;
        this.Code = code;
        this.Description = description;
    }

    private _Id: number;
    public get Id(): number {
        return this._Id;
    }
    public set Id(v: number) {
        this._Id = v;
    }


    private _Code: string;
    public get Code(): string {
        return this._Code;
    }
    public set Code(v: string) {
        this._Code = v;
    }

    private _Description: string;
    public get Description(): string {
        return this._Description;
    }
    public set Description(v: string) {
        this._Description = v;
    }
}

class CustomTrim {
    constructor(name: string, coilId: number, colorId: number, coilName: string, colorName: string, length: string,
        reversePaintedSide: boolean, blankWidth: string) {

    }
}
